// frontend/src/components/ScientificAnalysis/DatasetStats.tsx

import React from 'react';

interface Props {
  analysis: any;
}

const renderValue = (value: any): React.ReactNode => {
  if (value === null || value === undefined) return '—';
  if (Array.isArray(value)) return value.join(', ');
  if (typeof value === 'object') return JSON.stringify(value);
  return String(value);
};

const formatMemory = (mb: any): React.ReactNode => {
  if (mb === null || mb === undefined) return '—';
  const n = Number(mb);
  if (!Number.isFinite(n)) return String(mb);
  if (n >= 1024) return `${(n / 1024).toFixed(2)} GB`;
  return `${n.toFixed(2)} MB`;
};

const formatRows = (rows: any): React.ReactNode => {
  if (rows === null || rows === undefined) return '—';
  const n = Number(rows);
  if (!Number.isFinite(n)) return String(rows);
  if (n >= 1_000_000) return `${(n / 1_000_000).toFixed(1)}M`;
  if (n >= 1_000) return `${(n / 1_000).toFixed(1)}K`;
  return String(n);
};

export const DatasetStats: React.FC<Props> = ({ analysis }) => {
  const stats = [
    {
      icon: '📊',
      value: formatRows(analysis.total_rows),
      label: 'Registros'
    },
    {
      icon: '📋',
      value: renderValue(analysis.total_columns),
      label: 'Colunas'
    },
    {
      icon: '💾',
      value: formatMemory(analysis.memory_mb),
      label: 'Memória'
    },
    {
      icon: '📁',
      value: formatMemory(analysis.file_size_mb),
      label: 'Tamanho do Arquivo'
    }
  ];

  return (
    <div className="stats-grid" style={{
      display: 'grid',
      gridTemplateColumns: 'repeat(4, 1fr)',
      gap: '16px',
      marginBottom: '24px'
    }}>
      {stats.map((stat, index) => (
        <div
          key={index}
          style={{
            background: 'linear-gradient(135deg, #1a1a2e, #16213e)',
            borderRadius: '12px',
            padding: '16px',
            border: '1px solid #1a4a7a',
            textAlign: 'center'
          }}
        >
          <div style={{ fontSize: '28px', display: 'block', marginBottom: '4px' }}>
            {stat.icon}
          </div>
          <div style={{ fontSize: '20px', fontWeight: 600, color: '#4fc3f7' }}>
            {stat.value}
          </div>
          <div style={{ fontSize: '13px', color: '#8899aa' }}>
            {stat.label}
          </div>
        </div>
      ))}
    </div>
  );
};